import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";

import { AnalisePrestacaoContasService }
  from "../../core/services/prestacaoContas/analisePrestacaoContas.service";
import { ChecklistDocumentosService }
  from "../../core/services/prestacaoContas/checklistDocumentos.service";
import { PainelAnalisePcComponent } from "./painel-analise.component";

/**
 * Modulo minimo do painel da analise da prestacao de contas (ADR-0010).
 *
 * Uma declaracao so, importada pelos onze modulos de prestacao de contas — e nao onze copias
 * do componente, que e como as trinta telas de relatorio deste sistema chegaram a doze versoes
 * diferentes do mesmo numero (ADR-0009 §3.5). Segue o precedente do
 * {@code ConciliacaoBancariaPcModule}: modulo pequeno, para que quem o importa nao arraste as
 * quarenta declaracoes do PrestacaoContasSharedModule junto.
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
  ],
  declarations: [
    PainelAnalisePcComponent,
  ],
  exports: [
    PainelAnalisePcComponent,
  ],
  providers: [
    AnalisePrestacaoContasService,
    ChecklistDocumentosService,
  ],
})
export class PainelAnalisePcModule { }
